<lib-ribera-loader-ui [loader]="spinner.loading()" ></lib-ribera-loader-ui>
<div class="layout-wrapper">
  @if (isPromotorTogle() && isLoggedIn()) {
    <lib-sidebar-promoters class="desk sidebar-animation"
    (toggleSidebar)="toggleSidebar($event)"
    >
    </lib-sidebar-promoters>
  }@else if (isLoggedIn()) {
    <lib-sidebar-client
      class="sidebar sidebar-animation"
      [class.custom-display]="isLoggedIn()"
      (toggleSidebar)="toggleSidebar($event)"
    />
  }
  <div class="layout-main sidebar-animation" [ngClass]="{'layout-islogged': isLoggedIn(), 'layout-iscollapsed': isCollapsed()  }" >
    @if (isLoggedIn()) {
    <lib-header-promoters></lib-header-promoters>
    }@else {
      <lib-header-public-promoters
        class="header"
        [isCollapsed]="isCollapsed()"
      />
    }
    <main [ngClass]="{'main-islogged': isLoggedIn()}"  >
      <div class="outlet" [ngClass]="{'padding': isLoggedIn()}">
      @if (isDashboardRoute()) {
      <lib-promoters-profile-ui class="only-desktop"></lib-promoters-profile-ui>
      }
      @if (isLoggedIn()) {
      <lib-promoters-dashboard-tabs></lib-promoters-dashboard-tabs>
      }
      <div class="padding-outlet">
        <router-outlet></router-outlet>
      </div>
      </div>
      @if(viewSidebarRight()) {
      <div class="sidebar-right disabled " >
        <lib-my-rewards></lib-my-rewards>
        <lib-buy-rewards></lib-buy-rewards>
        <!-- <lib-promoters-wallet-transfer></lib-promoters-wallet-transfer> -->
      </div>
      }
    </main>
    @if (!isLoggedIn()) {
    <lib-footer/>
    }
  </div> 
</div>